<template>
  <div class="post-it">
    <article
      v-for="(hint, index) in hints"
      v-show="allHints"
      :key="index"
      class="post"
      :class="{ isOnTop: isOnTop(index) }"
      :style="flew(index) ? hintStyle(index) : hintStyle(index)"
      @click.stop.prevent="flyAway(top)"
    >
      <div class="content">
        <small v-if="index < 9">0{{ index + 1 }}</small>
        <small v-else>{{ index + 1 }}</small>
        <h2 class="h4">{{ hint.title }}</h2>
        <p>
          {{ hint.text }}
        </p>
      </div>
      <div class="background" :style="bg(index)"></div>
    </article>
    <div class="reset" @click="reset">
      <h2 class="h4 swBtn swPrimary">
        Vis tipsene igjen
      </h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["allHints"],
  data() {
    return {
      hints: [],
      flewAway: [],
      category: 0,
      top: 0,
    };
  },
  methods: {
    hintStyle(index) {
      let rotate = index % 10;
      if (index % 10 > 4) {
        rotate -= 4;
        rotate /= 2;
      }
      let vw = 50;
      if (index % 2) {
        rotate *= -1;
        vw *= 1;
      }
      if (
        typeof this.flewAway[index] != "undefined" &&
        this.flewAway[index].flew == 1
      ) {
        return {
          transform: "translate(-160vw, " + vw + "vw) rotate(-270deg) ",
          zIndex: 101,
        };
      } else {
        return {
          transform: "translate(0px) rotate(" + rotate + "deg)",
          zIndex: 100 - index,
        };
      }
    },
    isOnTop(index) {
      if (
        typeof this.flewAway[index] !== "undefined" &&
        this.flewAway[index].isOnTop == 1
      ) {
        return true;
      }
      return false;
    },
    flew(index) {
      if (
        typeof this.flewAway[index] !== "undefined" &&
        this.flewAway[index].flew == 1
      ) {
        return true;
      }
      return false;
    },

    flyAway(index) {
      this.flewAway[this.top].flew = 1;
      this.flewAway[this.top].isOnTop = 0;
      if (typeof this.flewAway[this.top + 1] !== "undefined") {
        this.flewAway[this.top + 1].isOnTop = 1;
        this.top++;
      }
    },
    reset() {
      this.flewAway[0].isOnTop = 1;
      this.top = 0;
      for (let i = 0; i < this.hints.length; i++) {
        this.flewAway[i].flew = 0;
      }
    },
    bg(index) {
      let i = index % 4;
      const bgs = ["#FFCDC5", "#f9efe7", "#B8DEFB", "#9AE2B9"];
      return {
        backgroundColor: bgs[i],
      };
    },
  },
  computed: {
    ...mapGetters(["getEmployment", "getTotal"]),
  },
  watch: {
    allHints: function(newVal, oldVal) {
      if (Array.isArray(newVal)) {
        this.hints = newVal;
        for (let i = 0; i < this.hints.length; i++) {
          let rotate = i % 10;
          if (i % 10 > 4) {
            rotate -= 4;
            rotate /= 2;
          }
          if (i % 2) {
            rotate *= -1;
          }

          this.flewAway.push({
            rotate: rotate,
            flew: 0,
            isOnTop: i == 0,
          });
        }
      }
    },
  },
  mounted() {
    if (Array.isArray(this.allHints)) {
      this.hints = this.allHints;
      for (let i = 0; i < this.hints.length; i++) {
        let rotate = i % 10;
        if (i % 10 > 4) {
          rotate -= 4;
          rotate /= 2;
        }
        if (i % 2) {
          rotate *= -1;
        }

        this.flewAway.push({
          rotate: rotate,
          flew: 0,
          isOnTop: i == 0,
        });
      }
    }
  },
};
</script>

<style lang="scss">
.post-it {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 450px;
  min-height: 510px;
  perspective: 1200px;
  margin: 40px 0;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-tap-highlight-color: transparent;
  outline: none !important;
  article {
    outline: none !important;
    position: absolute;
    color: rgb(52, 54, 87);
    transform-origin: 50% 50%;
    touch-action: manipulation;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 10px;
    cursor: pointer;
    transform: translateZ(0);
    backface-visibility: hidden;
    padding: 25px 30px 40px;
    transition: transform 0.4s ease-in 0s;
    z-index: 100;
    &:nth-child(20n + 1) {
      z-index: 100;
    }
    &:nth-child(20n + 2) {
      z-index: 99;
    }
    &:nth-child(20n + 3) {
      z-index: 98;
    }
    &:nth-child(20n + 4) {
      z-index: 97;
    }
    &:nth-child(20n + 5) {
      z-index: 96;
    }
    &:nth-child(20n + 6) {
      z-index: 95;
    }
    &:nth-child(20n + 7) {
      z-index: 94;
    }
    &:nth-child(20n + 8) {
      z-index: 93;
    }
    &:nth-child(20n + 9) {
      z-index: 92;
    }
    &:nth-child(20n + 10) {
      z-index: 91;
    }
    &:nth-child(20n + 11) {
      z-index: 90;
    }
    &:nth-child(20n + 12) {
      z-index: 89;
    }
    &:nth-child(20n + 13) {
      z-index: 88;
    }
    &:nth-child(20n + 14) {
      z-index: 87;
    }
    &:nth-child(20n + 15) {
      z-index: 86;
    }
    &:nth-child(20n + 16) {
      z-index: 85;
    }
    &:nth-child(20n + 17) {
      z-index: 84;
    }
    &:nth-child(20n + 18) {
      z-index: 83;
    }
    &:nth-child(20n + 19) {
      z-index: 82;
    }
    &:nth-child(20n + 20) {
      z-index: 81;
    }
    @media (min-width: 600px) {
      padding: 59px 53px 55px;
    }
    .content {
      outline: none !important;
      position: relative;
      z-index: 2;
      small {
        position: absolute;
        left: -37px;
        top: -42px;
        font-size: 18px;
        @media (max-width: 639px) {
          left: -23px;
          top: -21px;
          font-size: 15px;
        }
      }
      h2.h4 {
        padding-top: 0;
        margin-top: 0;
      }
    }
    .background {
      position: absolute;
      z-index: 1;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      transition: all 0.2s ease 0s;
    }
  }
}
.isOnTop {
  transform: none !important;
  transition: all 0.3s ease 0s;
}
</style>
